import type { AnalyticsReport, Period } from "@/app/analyticsQueries";
import { paceBar, paceNote, paceTotal } from "./model";

const H = 96;

/** Темп: сданных гейтов по неделям — простые SVG-столбики. Период влияет только сюда и на KPI «за период». */
export function Pace({ report, period }: { report: AnalyticsReport; period: Period }) {
  const pts = report.pace;
  const max = pts.reduce((a, p) => Math.max(a, p.gates), 0);
  const w = 100 / Math.max(1, pts.length);
  const dense = pts.length > 12;
  return (
    <section className="rounded-md border border-bd bg-card" data-testid="pace">
      <div className="flex items-baseline gap-3 border-b border-bd px-3.5 py-[9px]">
        <span className="font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">сданных гейтов по неделям</span>
        <span className="flex-1" />
        {pts.length > 0 && (
          <span className="font-mono text-[11.5px] text-ink2" data-testid="pace-total">
            {paceTotal(report)}
          </span>
        )}
      </div>
      <div className="px-3.5 py-3">
        {pts.length > 0 && (
          <>
            <svg viewBox={`0 0 100 ${H}`} preserveAspectRatio="none" className="block h-[96px] w-full" role="img" aria-label={`темп: ${pts.map((p) => `неделя ${p.week} — ${p.gates}`).join(", ")}`}>
              {pts.map((p, i) => {
                const b = paceBar(p.gates, max, H);
                return (
                  <rect
                    key={p.week}
                    data-testid="pace-bar"
                    data-week={p.week}
                    data-gates={p.gates}
                    data-warn={b.warn || undefined}
                    x={i * w + w * 0.15}
                    y={H - b.h}
                    width={w * 0.7}
                    height={b.h}
                    fill={b.warn ? "var(--warnsoft)" : "var(--accsoft)"}
                    stroke={b.warn ? "var(--warn)" : "var(--acc)"}
                    strokeWidth={1}
                    vectorEffect="non-scaling-stroke"
                  >
                    <title>{`неделя ${p.week}: ${p.gates}`}</title>
                  </rect>
                );
              })}
            </svg>
            <div className="mt-1 flex font-mono text-[10px] text-mut" aria-hidden>
              {pts.map((p, i) => (
                <span key={p.week} className="flex-1 text-center">
                  {!dense || i === 0 || i === pts.length - 1 ? `н${p.week}` : ""}
                </span>
              ))}
            </div>
          </>
        )}
        <p className="m-0 mt-2 text-[12px] leading-[1.45] text-ink2" data-testid="pace-note">
          {paceNote(report, period)}
        </p>
      </div>
    </section>
  );
}
